{
  "messages": {
    "maximumInSizeOnlyOneImageTextZipOrSpreadsheetAllowedToUploadMultipleDocsZipFirstThenUpload": "ขนาดสูงสุด {size} อนุญาตเฉพาะ {imageLimit}, {typeLimitText}, {typeLimitZip} หรือ {typeLimitSpreadsheet} หากต้องการอัปโหลดเอกสารหลายรายการ โปรดบีบอัดเป็นไฟล์ zip ก่อนแล้วจึงอัปโหลด",
    "maximumInSizePerFileOnlyImageTextZipSpreadsheetAllowed": "ขนาดสูงสุด {size} ต่อไฟล์ สูงสุด {count} ไฟล์ อนุญาตเฉพาะ {image}, {text}, {zip} หรือ {spreadsheet}",
    "oneImage": "รูปภาพหนึ่งรูป",
    "sizeInMegabytes": "{size} MB",
    "uploadDocument": "อัปโหลดเอกสาร",
    "uploadDocuments": "อัปโหลดเอกสาร"
  }
}
